import React, { Component } from 'react'
import { FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Field, ErrorMessage } from 'formik'


class PaymentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      busNoHint: false,
      highTnx: false,
    }
  }

  render() {
    const { disabled } = this.props

    return (
      <>
            {/* <h3>
              <img src="3.png" alt="no. step" className="num-icon half"/>
              Transactions
            </h3>         */}
        <Row className="enrolment-row">
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Annual Revenue</ControlLabel>
              <div className="hardcode-div">
                <span className="hardcode-field opaque-grey form-control" id="inputGroup-sizing-default">$
                <Field name="annual_rev" className="hrdcode-field" disabled={disabled}/>
                </span>
              </div>
              <ErrorMessage component="div" name="annual_rev" className="invalid-feedback"/>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Monthly Revenue</ControlLabel>
              <div className="hardcode-div">
                <span className="hardcode-field opaque-grey form-control" id="inputGroup-sizing-default">$
                <Field name="mthly_sale" className="hrdcode-field" disabled={disabled}/>
                </span>
              </div>
              <ErrorMessage component="div" name="mthly_sale" className="invalid-feedback"/>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Average Transaction Amount</ControlLabel>
              <div className="hardcode-div">
                <span className="hardcode-field opaque-grey form-control" id="inputGroup-sizing-default">$
                <Field name="avg_tnx" className="hrdcode-field" disabled={disabled}/>
                </span>
              </div>
              <ErrorMessage component="div" name="avg_tnx" className="invalid-feedback"/>
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Max Transaction
                <a className="hint-tip" onClick={() => this.setState({ highTnx: !this.state.highTnx })}>
                <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                {
                  this.state.highTnx?
                <div className="hint-tip-text" id="payment-hint">
                  <span>The highest, single transaction you expect to process</span>
                </div>
                : ''
                }
              </a>
              </ControlLabel>
              <div className="hardcode-div">
                <span className="hardcode-field opaque-grey form-control" id="inputGroup-sizing-default">$
                <Field name="max_tnx" className="hrdcode-field" disabled={disabled}/>
                </span>
              </div>
              <ErrorMessage component="div" name="max_tnx" className="invalid-feedback"/>
            </FormGroup>
          </Col>
        </Row>
      </>
    )
  }
}
  

export default PaymentDetails